import * as React from "react";
import { FunctionComponent} from 'react';

interface FilesTableProps
{
    files: File[];
    deleteFile: (index:number) => void;
};
export const FilesTable: FunctionComponent<FilesTableProps> = ({files, deleteFile}) => {
    function getKnownTypes(type:string)
    {
        switch (type)
        {
            case "audio/aac":
            case "audio/midi":
            case "audio/x-midi":
            case "audio/mpeg":
            case "audio/ogg":
            case "audio/opus":
            case "audio/wav":
            case "audio/webm":
                return "Audio";
            case "video/x-msvideo":
            case "video/mpeg":
            case "video/ogg":
            case "video/mp2t":
            case "video/webm":
            case "video/3gpp":
            case "video/3gpp2":
                return "Video";
            case "application/msword":
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                return "Word Doc";
            case "application/vnd.ms-powerpoint":
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                return "Powerpoint";
            case "application/vnd.ms-excel":
            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                return "Excel";
            case "image/jpeg":
            case "image/bmp":
            case "image/gif":
            case "image/png":
            case "image/svg+xml":
            case "image/tiff":
            case "image/webp":
                return "Image";
            case "application/pdf":
                return "PDF";
            case "application/x-bzip":
            case "application/x-bzip2":
            case "application/epub+zip":
            case "application/gzip":
            case "application/zip":
            case "application/x-7z-compressed":
            case "application/vnd.rar":
            case "application/x-zip-compressed":
                return "ZIP";
            case "text/csv":
                return "CSV";
            default:
                return type;
        }
    }


    return <div className="files-table">
                <table className="table table-striped">
                    <caption>Attached Files</caption>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Size</th>
                            <th>Type</th>
                            <th> </th>
                        </tr>
                    </thead>
                    <tbody>
                        {files!.map((file:File, i: number) =>{
                            return <tr key={file.name}>
                                        <td><a target="_blank" onClick={(e) =>{
                                            if ((window.document as any).documentMode && window.navigator.msSaveOrOpenBlob) {
                                                navigator.msSaveOrOpenBlob(file, file.name);
                                                e.preventDefault();
                                            }
                                            else return true;
                                        }} href={URL.createObjectURL(file)}>{file.name}</a></td>
                                        <td>{file.size < 10000 ? (file.size/1024/1024).toFixed(3) : (file.size/1024/1024).toFixed(2)}MB</td>
                                        <td>{getKnownTypes(file.type)}</td>
                                        <td className="delete" onClick={() =>{deleteFile(i);}}><i className="fa fa-trash-o" aria-label={`Delete file ${file.name}`} title={`Delete file ${file.name}`}/></td>
                            </tr>;
                            })
                        }
                    </tbody>
            </table>
    </div>;
}
